import React, { PropTypes } from 'react'
import { identity } from 'lodash'

import PaintSwatch from 'components/PaintSwatch'
import "./PaintSummary.css"

const PaintSummary = ({ paints, maxPaintfillColors, onClick = identity, selected}) => {
  
  let emptyPaints = [];
  for (var i = paints.length; i < maxPaintfillColors; i++) {
	var counter = i - 4;
	var emptyColor = {id: counter, label: 'No Color', colorCode: '', title: 'No Color', isTranslucent: false}
	
	emptyPaints.push(<PaintSwatch key={emptyColor.id} paint={emptyColor} onClick={onClick} />);
  }

  return (
    <div className="paint-summary">
      <span className="paint-summary-text">UP TO {maxPaintfillColors}: </span>
      <span className="paint-summary-swatches">
        {paints.map(p => (
          <PaintSwatch selected={(!!selected && !!selected.id && p.id === selected.id)} key={p.id} paint={p} onClick={onClick} />
        ))}
        {emptyPaints}
      </span>
    </div>
  );
};

PaintSummary.propTypes = {
  paints: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired, 
  })),
  maxPaintfillColors: PropTypes.number,
  onClick: PropTypes.func, 
}

export default PaintSummary